import { Component, Input, OnInit } from '@angular/core';
//import { settings } from 'cluster';
import { Subject, Subscription } from 'rxjs';
import { AlertService } from '../alert.service';
import { APIService } from '../api.service';
import { DataService } from '../data.service';
import { Player, Setting } from '../Main.Model';
import { HomeService } from '../Main.service';
import { RouterModule } from '@angular/router';

@Component({
    selector: 'app-home',
    templateUrl: './home.component.html',
    styleUrls: ['./home.component.css'],
    standalone: false
})
export class HomeComponent implements OnInit {

  constructor(public DataService: DataService, private AlertService: AlertService) {   }

  public ngOnInit(): void {
    //this.DataService.refreshPlayers();//is done in app component so we cannot auto log user in from cookie
    this.DataService.refreshMatches();
    this.DataService.refreshTorns();
  }

  EditCalendarText() {
    this.AlertService.showChangeCalendarTextDialog = true;
  }
  
}
